module.exports = __webpack_public_path__ + "img/I2.6c55f1f2.png";